<template>
  <product-shop-the-look-elevate v-if="$feature.pdpShopTheLookElevated" />
  <product-shop-the-look v-else />
</template>
